export const FORM_SECTIONS = [
  {
    id: "basicInfo",
    title: "Basic Information",
    subtitle: "Character name, portrait, and core details",
    required: true,
    lockable: true,
    order: 1,
  },
  {
    id: "heritage",
    title: "Heritage",
    subtitle: "Character species and innate abilities",
    required: true,
    lockable: true,
    order: 2,
  },
  {
    id: "abilityScores",
    title: "Ability Scores",
    subtitle: "Character attributes and modifiers",
    required: true,
    lockable: true,
    order: 4,
  },
  {
    id: "background",
    title: "Background",
    subtitle: "Character background and starting proficiencies",
    required: true,
    lockable: true,
    order: 5,
  },
  {
    id: "progression",
    title: "Level Progression",
    subtitle: "ASI, feats, and level-based features",
    required: false,
    lockable: true,
    order: 6,
  },
  {
    id: "skills",
    title: "Skills & Proficiencies",
    subtitle: "Skill proficiencies and expertise",
    required: false,
    lockable: true,
    order: 7,
  },
  {
    id: "toolsLanguages",
    title: "Tool Proficiencies",
    subtitle: "Tool proficiencies",
    required: false,
    lockable: true,
    order: 8,
  },
  {
    id: "magic",
    title: "Magic Modifiers",
    subtitle: "Spell attack bonus and save DC",
    required: false,
    lockable: true,
    order: 9,
  },
  {
    id: "castingStyleChoices",
    title: "Casting Style Features",
    subtitle: "Level-based casting style feature choices",
    required: false,
    lockable: true,
    order: 10,
  },
];

export const FORM_MODES = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};
